(function ($) {
    $(window).on('load resize', function () {
        var winInnerheight = $(window).innerHeight();
        $("#page").css("height", winInnerheight + 'px');

        if ($('#wpadminbar').length) {
            var wpAdminBar = $('#wpadminbar').outerHeight();
            $("#page").css("height", winInnerheight-wpAdminBar + 'px');
        } else {
            $("#page").css("height", winInnerheight + 'px');
        }

        $('.baloon-pop').each(function() {
            var $this = $(this),
                $parent = $this.parent(),
                parentTop = $parent.offset().top,
                parentLeft = $parent.offset().left,
                parentHeight = $parent.innerHeight(),
                top = parentTop - parentHeight;

            $this.css({
                top: top,
                left: parentLeft
            });

            console.log(parentTop)
        })
    });

    const $langSelector = $('.js-lang-selector');
    const $closeLangSelector = $('.js-close-lang');
    const $selectorBg = $('.languageSelector__bg');
    const $lang = $('.js-lang');

    $langSelector.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(e.currentTarget);
        $this.parents('.languageSelector').addClass('is-opened');
    });

    $closeLangSelector.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(e.currentTarget);
        $this.parents('.languageSelector').removeClass('is-opened');
    });

    $selectorBg.on('click', function(e) {
        $('.languageSelector').removeClass('is-opened');
    });

    $lang.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(e.currentTarget);
        const langCode = $this.attr('data-lang-code');

        if ($this.hasClass('is-selected')) {
            $closeLangSelector.trigger('click');
            return false;
        }

        window.location.href = CFG.currentURL + '?lang=' + langCode;
        return false;
    });
 
    $(document).on('click', '.baloon', function() {
        var dataLabel   = $(this).data('label'),
            innerHeight = $(this).innerHeight(),
            offsetTop   = $(this).offset().top,
            offsetLeft  = $(this).offset().left,
            top         = offsetTop-innerHeight;


        $('.baloon').not($(this)).find('.baloon-pop').remove();
        
        $(this).append('<div class="baloon-pop" style="top:'+top+'px; left:'+offsetLeft+'px">'+dataLabel+'</div>');

    });

    $(document).click((event) => {
        if (!$(event.target).closest('.baloon').length) {
            $('.baloon').find('.baloon-pop').remove();
        }        
    });


})(jQuery);
 